export default ({ Vue }) => {
  Vue.prototype.$urlAPI = 'https://api.sistema.unclik.com.br';
  Vue.prototype.$banks = [];
  Vue.prototype.$bankall = [];
  Vue.prototype.$transactionCategory = [];
  Vue.prototype.$commonBanks = {
    1: {bg: '#fcfc2c', text: '#445eff'}, // Banco do Brasil
    184: {bg: '#00309a', text: '#ffff00'}, // Itaú
    341: {bg: '#00309a', text: '#ffff00'}, // Itaú
    273: {bg: '#f10447', text: '#ffffff'}, // Bradesco
    33: {bg: '#ec0c1e', text: '#ffffff'}, // Santander
    208: {bg: '#195ab4', text: '#fffbff'}, // BTG
    260: {bg: '#830ad1', text: '#f6f6f6'}, // Nubank
    77: {bg: '#ff7a00', text: '#ffffff'}, // Inter
    623: {bg: '#00b0ff', text: '#ffffff'}, // PAN
    637: {bg: '#f9b12d', text: '#01a990'}, // Sofisa
    70: {bg: '#00c0ff', text: '#173f7b'}, // BRB
    403: {bg: '#202020', text: '#fe3e6d'}, // Cora
    104: {bg: '#1b6eb4', text: '#fffdfe'}, // Caixa
    380: {bg: '#11c76f', text: '#ffffff'}, // Caixa
  }
}
